import {Component, inject, Input, OnInit} from '@angular/core';
import { forkJoin } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { SafePipe } from 'src/app/pipes/filter.pipe';
import { TranslationService } from 'src/app/service/translation.service';
import { environment } from 'src/environments/environment';


/** Statistics Component only available for admins */
@Component({
    selector: 'app-statistics',
    templateUrl: './statistics.component.html',
    styleUrls: ['./statistics.component.scss'],
    providers: [TranslationService],
    imports: [ TranslateModule, SafePipe ],
    standalone: true
})
export class StatisticsComponent implements OnInit {

  private readonly translationService = inject(TranslationService);
  @Input() type?:string
  public env = environment;

  ngOnInit(): void {
     
    if (this.type === 'compromise-reports') {
      forkJoin([
        this.translationService.get('menu-compromise-reports'),
        this.translationService.get('compromise-reports-nav-statistics')
      ]).subscribe(([menuCompromiseReportsValue, navStatisticsValue]) => {
        document.title = `DIP - ${menuCompromiseReportsValue} - ${navStatisticsValue}`;
      });
    }
    if (this.type === 'attestations') {
      forkJoin([
        this.translationService.get('menu-attestations'),
        this.translationService.get('attestations-nav-statistics')
      ]).subscribe(([menuAttestationsValue, navStatisticsValue]) => {
        document.title = `DIP - ${menuAttestationsValue} - ${navStatisticsValue}`;
      });
    }
  }

}
